import React, {useState, useEffect, useRef} from 'react';
import Slider from 'react-slick';
import ReactDOM from "react-dom/client";
import LocalizedStrings from "react-localization";


function getYearsText(age, language) {
    const lastDigit = age % 10;
    const lastTwoDigits = age % 100;

    if (language === 'et') {
        if (lastTwoDigits === 1) {
            return "aasta";
        } else {
            return "aastat";
        }
    } else {
        if (lastTwoDigits >= 5 && lastTwoDigits <= 20) {
            return "лет";
        } else if (lastDigit === 1) {
            return "год";
        } else if (lastDigit >= 2 && lastDigit <= 4) {
            return "года";
        } else {
            return "лет";
        }
    }
}

let strings = new LocalizedStrings({
    ru: {
        trainers: "Тренеры",
        sport_experience: "Спортивный опыт",
        coaching_experience: "Тренерский опыт",
        group_lessons: "Групповые занятия",
        personal_lessons: "Персональные занятия"

    },
    et: {
        trainers: "Treenerid",
        sport_experience: "Spordikogemus",
        coaching_experience: "Treenerikogemus",
        group_lessons: "Rühmatunnid",
        personal_lessons: "Individuaalsed õppetunnid"
    },
});

const language = localStorage.getItem('language');

const TrainerSlider = () => {
    strings.setLanguage(language);
    const sliderRef = useRef(null);

    const handleNextSlide = () => {
        sliderRef.current.slickNext();
    };

    const handlePreviousSlide = () => {
        sliderRef.current.slickPrev();
    };

    const [trainers, setTrainers] = useState([]);

    useEffect(() => {
        fetch('/trainers')
            .then((response) => response.json())
            .then((data) => {
                setTrainers(data);
                if (sliderRef.current) {
                    sliderRef.current.slickGoTo(0, true);
                }
            });
    }, []);

    const settings = {
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <div className="xl:max-w-[1200px] lg:max-w-[936px] mx-auto max-w-full pt-12 lg:pt-16 pb-12 px-4">
            <div className="flex items-center justify-between mb-1 lg:mb-14">
                <h2 className="mx-auto w-fit xl:text-5xl text-4xl font-normal text-dark-main uppercase">
                    {strings.trainers}
                </h2>
                <div className="hidden md:block">
                    <button className="custom-prev-button" onClick={handlePreviousSlide}>
                        <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M26 45.5C15.2304 45.5 6.5 36.7696 6.5 26C6.5 15.2304 15.2304 6.5 26 6.5C36.7696 6.5 45.5 15.2304 45.5 26C45.5 36.7696 36.7696 45.5 26 45.5Z"
                                stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M28.1667 19.5L21.6667 26L28.1667 32.5" stroke="#333333" strokeWidth="2"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <button className="custom-next-button" onClick={handleNextSlide}>
                        <svg width="52" height="52" viewBox="0 0 52 52" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M26 45.5C36.7696 45.5 45.5 36.7696 45.5 26C45.5 15.2304 36.7696 6.5 26 6.5C15.2304 6.5 6.5 15.2304 6.5 26C6.5 36.7696 15.2304 45.5 26 45.5Z"
                                stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M23.8333 19.5L30.3333 26L23.8333 32.5" stroke="#333333" strokeWidth="2"
                                  strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>

            <div className="">
                <Slider ref={sliderRef} {...settings}>
                    {trainers.map((trainer) => (
                        <div className="slick-slide" key={trainer.id}>
                            <div
                                className="flex flex-col sm:mr-4 lg:mr-7 bg-white">
                                <img className="lg:w-72 lg:h-72 h-60 object-cover"
                                     src={trainer.image_url} alt={trainer.name}/>

                                <div className="h-80 flex flex-col justify-between">
                                    <div className="m-3 mb-0 lg:mb-0 lg:m-4">
                                        <p className="text-xs text-gray-500">{language === 'ru' ? trainer.position : trainer.position_et}</p>
                                        <p className="text-base font-bold mb-4">{trainer.name}</p>

                                        {trainer.sport_experience && (
                                            <div>
                                                <span
                                                    className="text-sm font-semibold">{strings.sport_experience}: </span>
                                                <span
                                                    className="text-sm text-gray-500">{trainer.sport_experience}  {getYearsText(trainer.sport_experience, language)}</span>
                                            </div>
                                        )}

                                        {trainer.coaching_experience && (
                                            <div>
                                                <span
                                                    className="text-sm font-semibold">{strings.coaching_experience}: </span>
                                                <span
                                                    className="text-sm text-gray-500">{trainer.coaching_experience} {getYearsText(trainer.coaching_experience, language)}</span>
                                            </div>
                                        )}

                                        {language === 'ru' && trainer.specialization && (
                                            <div>
                                                <p className="text-sm text-gray-500">{trainer.specialization}</p>
                                            </div>
                                        )}

                                        {language === 'et' && trainer.specialization_et && (
                                            <div>
                                                <p className="text-sm text-gray-500">{trainer.specialization_et}</p>
                                            </div>
                                        )}
                                    </div>

                                    <div className="m-3 lg:m-4">
                                        <div className="mx-auto items-center">
                                            <a href={`/personal-trainings`}
                                               className="inline-block p-2.5 lg:px-4 text-sm font-semibold bg-blue-500 text-white rounded-md hover:bg-blue-700 flex items-center justify-center whitespace-nowrap"
                                            >
                                                {strings.personal_lessons}
                                                <svg className="ml-1" width="20" height="20" viewBox="0 0 20 20"
                                                     fill="none"
                                                     xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.125 10H16.875" stroke="white" strokeWidth="2"
                                                          strokeLinecap="round" strokeLinejoin="round"/>
                                                    <path d="M11.25 4.375L16.875 10L11.25 15.625" stroke="white"
                                                          strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </a>
                                        </div>

                                        {trainer.open_group_exist && (
                                            <div className="mt-3 mx-auto items-center">
                                                <a href={`/group/register?trainer=${trainer.id}`}
                                                   className="inline-block p-2.5 lg:px-4 font-semibold text-sm border-[1px] border-solid border-black rounded-md hover:bg-gray-500 flex items-center justify-center whitespace-nowrap">
                                                    {strings.group_lessons}
                                                    <svg className="w-5 h-5 ml-1" width="21" height="20" viewBox="0 0 21 20"
                                                         fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3.625 10H17.375" stroke="#333333" strokeWidth="2"
                                                              strokeLinecap="round" strokeLinejoin="round"/>
                                                        <path d="M11.75 4.375L17.375 10L11.75 15.625" stroke="#333333"
                                                              strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </a>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
            <div className="md:hidden text-center mt-6">
                <button className="custom-prev-button" onClick={handlePreviousSlide}>
                    <svg width="36" height="36" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26 45.5C15.2304 45.5 6.5 36.7696 6.5 26C6.5 15.2304 15.2304 6.5 26 6.5C36.7696 6.5 45.5 15.2304 45.5 26C45.5 36.7696 36.7696 45.5 26 45.5Z"
                            stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M28.1667 19.5L21.6667 26L28.1667 32.5" stroke="#333333" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <button className="custom-next-button" onClick={handleNextSlide}>
                    <svg width="36" height="36" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M26 45.5C36.7696 45.5 45.5 36.7696 45.5 26C45.5 15.2304 36.7696 6.5 26 6.5C15.2304 6.5 6.5 15.2304 6.5 26C6.5 36.7696 15.2304 45.5 26 45.5Z"
                            stroke="#333333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M23.8333 19.5L30.3333 26L23.8333 32.5" stroke="#333333" strokeWidth="2"
                              strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>
        </div>
    );
};

const section = document.getElementById("trainers");
if (section) {
    const root = ReactDOM.createRoot(
        document.getElementById("trainers")
    );
    root.render(<TrainerSlider/>);
}
